export enum CampaignBuilderMode {
    CREATE,
    EDIT,
    READONLY,
}

export enum CampaignEditableState {
    EDITABLE,
    RUNNING,
    COMPLETED,
    // readonly editableState corresponds with READONLY CampaignBuilderMode
    READONLY,
}
